import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { Input } from '../Input';
import { EmptyPage } from '../../pages/EmptyPage';

export const PopupList = ({ children, listClassName = '', search = null, closeFn, title, button }) => {
    const outsideClickHandler = (evt) => {
        evt.target === evt.currentTarget && closeFn();
    };
    const [searchValue, setSearch] = useState('');
    
    const list = children.map((el) => {
         //Добавляем класс в зависимости от индекса
        const curClassName = el.props.className;
        const className = `popup__item ${curClassName||''}`;
        return React.cloneElement(el, { className }); 
    });
    const filterFunc = search.createSearch(list, searchValue)
    const filteredList = !search ? list : list.filter(filterFunc);

    return createPortal(
        <div className="popup-wrapper" onMouseDown={outsideClickHandler}>
            <div className="popup dark-theme-bg0">
                <div className="popup__header">
                    <h3 className="popup__title">{title}</h3>
                    <div className="popup__close-button" onClick={closeFn}>x</div>
                    {search && <div className="popup__search"><Input placeholder='поиск' value={searchValue} changeHandler={(e) => setSearch(e.target.value)}/></div>}
                </div>
                <div className="popup__body">
                    <div className={`popup__list ${listClassName}`}>
                        {filteredList.length ? filteredList : <EmptyPage message='Список пуст'/>}
                    </div>
                </div>
                <div className="popup__footer">{button}</div>
            </div>
        </div>,
        document.getElementById('popup-root'),
    );
};
